var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAddPhotoHs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "43px",
    height: "42px",
    viewBox: "0 0 43 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icAddPhotoHS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-header4-Final",
    transform: "translate(-532.000000, -281.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LeftSide-Bar",
    transform: "translate(358.000000, 172.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-profile-v2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-70",
    transform: "translate(77.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icAddPhotoHS",
    transform: "translate(98.000000, 87.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#74CD2D",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4255319,17.5 C18.5217447,17.5 16.9787234,19.0365638 16.9787234,20.9308511 C16.9787234,22.8258245 18.5217447,24.3617021 20.4255319,24.3617021 C22.3288596,24.3617021 23.8723404,22.8258245 23.8723404,20.9308511 C23.8723404,19.0365638 22.3288596,17.5 20.4255319,17.5 Z M29.6170213,14.0691489 L26.8595745,14.0691489 C26.4804255,14.0691489 26.0718638,13.776383 25.9521447,13.4182021 L25.2393447,11.289016 C25.119166,10.9310638 24.7110638,10.6382979 24.3319149,10.6382979 L16.5191489,10.6382979 C16.14,10.6382979 15.7314383,10.9310638 15.6117191,11.2892447 L14.8989191,13.4184309 C14.7787404,13.776383 14.3706383,14.0691489 13.9914894,14.0691489 L11.2340426,14.0691489 C9.97021277,14.0691489 8.93617021,15.0984043 8.93617021,16.356383 L8.93617021,26.6489362 C8.93617021,27.9069149 9.97021277,28.9361702 11.2340426,28.9361702 L29.6170213,28.9361702 C30.8808511,28.9361702 31.9148936,27.9069149 31.9148936,26.6489362 L31.9148936,16.356383 C31.9148936,15.0984043 30.8808511,14.0691489 29.6170213,14.0691489 Z M20.4255319,26.6489362 C17.2528596,26.6489362 14.6808511,24.0888351 14.6808511,20.9308511 C14.6808511,17.7730957 17.2528596,15.212766 20.4255319,15.212766 C23.5977447,15.212766 26.1702128,17.7730957 26.1702128,20.9308511 C26.1702128,24.0888351 23.5977447,26.6489362 20.4255319,26.6489362 Z M28.812766,17.9558457 C28.368817,17.9558457 28.0085106,17.5976649 28.0085106,17.1553138 C28.0085106,16.7134202 28.368817,16.3547819 28.812766,16.3547819 C29.2571745,16.3547819 29.6170213,16.7134202 29.6170213,17.1553138 C29.6170213,17.5976649 29.2569447,17.9558457 28.812766,17.9558457 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-6",
    stroke: "#74CD2D",
    strokeWidth: 3,
    fill: "#FFFFFF",
    cx: 33.6170213,
    cy: 31.4893617,
    r: 5.95744681
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2703647,30.9422492 L34.5896657,30.9422492 L34.5896657,29.2615502 C34.5896657,28.8486322 34.2428571,28.5106383 33.8297872,28.5106383 C33.4167173,28.5106383 33.0699088,28.8486322 33.0699088,29.2615502 L33.0699088,30.9422492 L31.3892097,30.9422492 C30.9762918,30.9422492 30.6382979,31.2890578 30.6382979,31.7021277 C30.6382979,32.1151976 30.9762918,32.4620061 31.3892097,32.4620061 L33.0699088,32.4620061 L33.0699088,34.1427052 C33.0699088,34.5556231 33.4167173,34.893617 33.8297872,34.893617 C34.2428571,34.893617 34.5896657,34.5556231 34.5896657,34.1427052 L34.5896657,32.4620061 L36.2703647,32.4620061 C36.6832827,32.4620061 37.0212766,32.1151976 37.0212766,31.7021277 C37.0212766,31.2890578 36.6832827,30.9422492 36.2703647,30.9422492 Z",
    id: "Shape",
    fill: "#74CD2D"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddPhotoHs);
export default __webpack_public_path__ + "static/media/icAddPhotoHS.227e4fca223f624b361d5492ba0d80fe.svg";
export { ForwardRef as ReactComponent };